import { render } from "./tenant.vue?vue&type=template&id=19fd2197&scoped=true"
import script from "./tenant.vue?vue&type=script&lang=js"
export * from "./tenant.vue?vue&type=script&lang=js"

import "./tenant.vue?vue&type=style&index=0&id=19fd2197&scoped=true&lang=less"
import "./tenant.vue?vue&type=style&index=1&id=19fd2197&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fd2197"]])

export default __exports__